<div>

  
    <div *ngIf="session" class="video-view">
        <div id="layoutContainer" #subscriberDiv>
            <app-publisher (videoClosed)="closeVideo()" #publisher [session]="session" [name]="name"></app-publisher> 
        </div>
        <label *ngIf="enableWaitingSign" class="waiting-sign-cs"> {{'ConnectionWaiting' | translateOrgSpecific}}</label>
        <a id="lnkClose" class="grid-link" (click)="closeVideo()">
            <i class="fas fa-times video-close" aria-hidden="true"></i>
            <i  class="video-label" aria-hidden="true" *ngIf="isAnonymous && secretCode">{{ 'PleaseKeepNoteOfTheBelow' | translateOrgSpecific }} <br>
                {{ 'RequestCodeForYourSubsequentSession' | translateOrgSpecific }} <br>
               <span style="color: red;font-weight: bold;">{{ secretCode }}</span> </i>
        </a>
        <a *ngIf="!isAudioOnly" id="audio-common" class="grid-link" (click)="audio()">
          <img class="audio-icon" src="../../assets/headphones.png" alt="image" />
      </a>
      <a *ngIf="isAudioOnly" id="video-common" class="grid-link" (click)="video()">
          <img class="video-icon" src="../../assets/video-camera.png" alt="image" />
      </a>
    </div>



</div>
<div class="info-popup" style="width:315px; z-index: 20000; " *ngIf="VideoCallCloseConfirm">
    <div style="margin:12px;">
      <div style="margin-left:10px;">
        <div>{{ 'VideoCallCloseConfirmation' | translateOrgSpecific }}</div>
      </div>
      <div style="margin-top: 10px;margin-left: 10px;">
        <button style="width:100px;display: inline-block;margin-top:0px;" class="btn btn-apportis-primary-theme btn-block"
          (click)="ConfirmClose()"> {{ 'Confirm' | translateOrgSpecific }}</button>
        <button style="width:100px;display: inline-block;margin-top:0px;margin-left:10px"
          class="btn btn-apportis-primary-theme btn-block"
          (click)="cancelCloseVideo()">{{ 'Cancel' | translateOrgSpecific }}</button>
      </div>
    </div>
 </div>
 <app-msg-box #msgbox></app-msg-box>